export const SSO_FEATURE_ID = "sso"
